import { useContext } from 'react';
import { AbilityContext } from './AbilityContext';

/**
 * Hook to get the current ability instance
 */
export const useAbility = () => useContext(AbilityContext);

/**
 * Hook for convenient permission checking
 */
export const usePermissions = () => {
  const ability = useAbility();
  
  return {
    ability,
    can: (action: string, subject: string, resource?: string) => ability.can(action, subject, resource),
    cannot: (action: string, subject: string, resource?: string) => ability.cannot(action, subject, resource),
  };
}; 